<template>
  <v-app>
    <app-header> abcd </app-header>
    <v-main>
      <router-view />
    </v-main>
    <v-snackbar v-model="bar" timeout="-1">
      利便性向上のためにCookieを利用してもよいですか？<router-link to="/privacy">詳細</router-link>
      <template v-slot:action="{ attrs }">
        <span>
        <v-btn
          color="primary"
          text
          v-bind="attrs"
          @click="enablePlugin()"
        >
          受け入れる
        </v-btn><br/>
        <v-btn
          color="pink"
          text
          v-bind="attrs"
          @click="disablePlugin()"
        >
          拒否する
        </v-btn>
        </span>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import AppHeader from "@/components/AppHeader";
import { bootstrap } from "vue-gtag";

export default {
  name: "App",

  components: {
    AppHeader,
  },
  data: () => ({
    bar: false,
  }),
  created() {
    if(this.$store.state.accepted === 0) {
      this.bar = true;
    } else if(this.$store.state.accepted === 2) {
      this.enablePlugin();
    }
    this.$store.dispatch('gabageLogs');
  },
  methods: {
    enablePlugin() {
      bootstrap().then(() => {
        this.$store.dispatch('acceptCookie', 2);
        this.bar = false;
      });
    },
    disablePlugin(){
      this.$store.dispatch('acceptCookie', 1);
      this.bar = false;
    }
  },
};
</script>
<style>
#app {
  background: #efefef;
}
</style>